import { Details, Divider, Summary } from '@hs-baumappe/legacy-ui';
import { Alert, Box, Text } from '@hs-baumappe/ui';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { type DriveDocumentLogsProps } from 'coreWeb/DriveDocumentLogs';
import ErrorBoundary from '../../ErrorBoundary';

const CoreDriveDocumentLogs = lazy(() => import('coreWeb/DriveDocumentLogs'));

export default function DriveDocumentLogs(props: DriveDocumentLogsProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <ErrorBoundary
      fallback={
        <Alert type="error">
          <Text>{t('activityLogs.loadError')}</Text>
        </Alert>
      }
    >
      <Suspense>
        <Details
          renderSummary={({ onClick }) => (
            <Summary onClick={onClick}>
              <Text variant="label-large">{t('activityLogs.title')}</Text>
            </Summary>
          )}
        >
          <Divider stylex={{ marginEnds: 'small-3x' }} />
          <Box xstyle={{ paddingBlock: 'small' }}>
            <CoreDriveDocumentLogs {...props} />
          </Box>
        </Details>
      </Suspense>
    </ErrorBoundary>
  );
}
